var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rank-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "rank-main page-main"
  }, [_c('div', {
    staticClass: "rank__title"
  }, [_vm._v("Ranking")]), _c('div', {
    staticClass: "rank-list"
  }, [_c('div', {
    staticClass: "rank-item user"
  }, [_c('div', {
    staticClass: "rank-item__code"
  }, [_vm.userRank <= 2 ? _c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/rank-${_vm.userRank}.png`),
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.userRank))])]), _c('div', {
    staticClass: "rank-item-info"
  }, [_c('div', {
    staticClass: "rank-item__head"
  }, [_vm.userInfo.avatar ? _c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }) : _c('m-head-img', {
    attrs: {
      "name": _vm.userInfo,
      "bgColor": _vm.userInfo.head_color
    }
  })], 1), _c('div', {
    staticClass: "rank-item__name"
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))])]), _c('div', {
    staticClass: "rank-item__price"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.userInfo.coin)))])]), _vm.personalList ? [_vm.personalList.length > 0 ? _vm._l(_vm.personalList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "rank-item"
    }, [_c('div', {
      staticClass: "rank-item__code"
    }, [index <= 2 ? _c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/rank-${index + 1}.png`),
        "alt": ""
      }
    }) : _c('span', [_vm._v(_vm._s(index + 1))])]), _c('div', {
      staticClass: "rank-item-info"
    }, [_c('div', {
      staticClass: "rank-item__head"
    }, [item.avatar ? _c('img', {
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }) : _c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "rank-item__name"
    }, [_vm._v(_vm._s(item.nickname))])]), _c('div', {
      staticClass: "rank-item__price ran"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.fmt_pre(item.coin)))])]);
  }) : _vm._e()] : _vm._e()], 2)]), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };